'use strict';
moduleConfig.registerModule('eclipseApp.brt', ['ute.ui', 'eclipseApp']);
